import React, { useState } from "react";
import SelecionarBusca from "../../components/SelecionarBusca";
import { Row, Col, Form } from "react-bootstrap";
import { FiltroCabecalho } from "../../components/FiltroCabecalho";
import { ModeloProduto } from "../../core/models/produto";
import { useTranslation } from "react-i18next";
import MonthRangePicker from "../../components/MonthRangePicker";
import { TipoTela } from "../../core/config/tipoTela";
import { useToast } from "../../core/contexts/toast";
import { ModeloSopBusinessUnit } from "../../core/models/sopBusinessUnit";
import { ModeloSopIndustrialPlant } from "../../core/models/sopIndustrialPlant";
import { ModeloSopProductFamily } from "../../core/models/sopProductFamily";
import { ModeloSopProduto } from "../../core/models/sopProduto";
import { ModeloSopRegion } from "../../core/models/sopRegion";
import { RepositorioSopBusinessUnit } from "../../core/repositories/sopBusinessUnitRepositorio";
import { RepositorioSopIndustrialPlant } from "../../core/repositories/sopIndustrialPlantRepositorio";
import { FiltroSopProduto, RepositorioSopProduto } from "../../core/repositories/sopProdutoRepositorio";
import { RepositorioSopRegion } from "../../core/repositories/sopRegionRepositorio";
import { FiltroSopProduction } from "../../core/repositories/sopProductionRepositorio";



interface Props {
  titulo: string;
  filtro: FiltroSopProduction;
  permissaoEditar: boolean;
  atualizarFiltro: (filtro: FiltroSopProduction) => void;
  filtrarDados: (filtro: FiltroSopProduction) => void;
}

export default function FiltroPI(props: Props) {
  const { t } = useTranslation();
  const { mostrarToast } = useToast();

  const [listaBusinessUnit, setListaBusinessUnit] = useState<ModeloSopBusinessUnit[]>([]);
  const [listaSopRegion, setListaSopRegion] = useState<ModeloSopRegion[]>([]);
  const [listaSopIndustrialPlant, setListaSopIndustrialPlant] = useState<ModeloSopIndustrialPlant[]>([]);
  const [listaSopProduto, setListaSopProduto] = useState<ModeloSopProduto[]>([]);
  const [listaSopProductFamily, setListaSopProductFamily] = useState<ModeloSopProductFamily[]>([]);

  React.useEffect(() => {
    try {
      carregarSopProduto();

      carregaLista();
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }, []);

  function carregarSopProduto() {
    props.filtro.cod_product = ""
    const filtroSopProduto = new FiltroSopProduto();
    filtroSopProduto.cod_product_family = props.filtro.cod_product_family;
    new RepositorioSopProduto().getFilter(filtroSopProduto).then((res) => {
      setListaSopProduto(res);
    }).catch((error) => {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    })
  }

  async function carregaLista() {
    try {
      setListaBusinessUnit(await new RepositorioSopBusinessUnit().getAll())
      setListaSopRegion(await new RepositorioSopRegion().getAll())
      setListaSopIndustrialPlant(await new RepositorioSopIndustrialPlant().getAll())

    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }

  return (
    <div className="stick">
      <FiltroCabecalho
        titulo={props.titulo}
        filtro={props.filtro}
        atualizarFiltro={props.atualizarFiltro}
        tipoTela={TipoTela.SAZONALIDADE}
      >
        <>
          <Row className="row-cols-2 row-cols-lg-7">
            <Col>
              <MonthRangePicker
                startDate={props.filtro.dth_inicio}
                endDate={props.filtro.dth_fim}
                onRangeChange={(start, end) => {
                  props.filtro.dth_inicio = start;
                  props.filtro.dth_fim = end;
                  props.atualizarFiltro(props.filtro)
                }} />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Business Unit")}
                optionLabel="des_business_unit"
                optionValue="cod_business_unit"
                multiple
                value={props.filtro.cod_business_unit}
                options={listaBusinessUnit}
                onChange={(value) => {
                  props.filtro.cod_business_unit = value
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            {/* <Col>
              <SelecionarBusca
                titulo={t("Region")}
                optionLabel="des_region"
                optionValue="cod_region"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_region}
                options={listaSopRegion}
                onChange={(value) => {
                  props.filtro.cod_region = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}

            <Col>
              <SelecionarBusca
                titulo={t("Manufacturing Plant")}
                optionLabel="des_industrial_plant"
                optionValue="cod_industrial_plant"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaSopIndustrialPlant}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product Family")}
                optionLabel="des_product_family"
                optionValue="cod_product_family"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_product_family}
                options={listaSopProductFamily}
                onChange={(value) => {
                  props.filtro.cod_product_family = value;
                  carregarSopProduto()
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col>
              <SelecionarBusca
                titulo={t("Product")}
                optionLabel="des_product"
                optionValue="cod_product"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_product}
                options={listaSopProduto}
                onChange={(value) => {
                  props.filtro.cod_product = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            {/* <Col>
              <SelecionarBusca
                titulo={t("Production Phase")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>


            <Col>
              <SelecionarBusca
                titulo={t("Machine")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}

            {/* <Col>
              <Form.Group className="mb-3 mr-3 SelectSearch me-2">
                <Form.Label className="font-size-14">{t("Purchase for Resale")}</Form.Label>
                <br />
                <SwitchItem
                  checked={props.filtro.resale}
                  onChange={(checked) => {
                    props.filtro.resale = checked;
                    props.atualizarFiltro(props.filtro)
                  }}
                ></SwitchItem>
              </Form.Group>
            </Col> */}

            {/* <Col>
              <SelecionarBusca
                titulo={t("Production Cost")}
                optionLabel="des_produto"
                optionValue="cod_produto"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_produto_capitao}
                options={listaProduto}
                onChange={(value) => {
                  props.filtro.cod_produto_capitao = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}

            {/* <ValueComponent value={props.filtro.value} atualizarFiltro={(value: any) => { props.filtro.value = value; props.atualizarFiltro(props.filtro) }}/> */}



          </Row>
        </>
      </FiltroCabecalho>
    </div>
  );
}


